import { useState } from "react";
import { motion as m, AnimatePresence } from "framer-motion";
import { ArrowDown2, ArrowUp2 } from "iconsax-react";

const SectionCard = ({
  title,
  description,
  children,
  className,
  collapsible,
  defaultUncollapsedState = true,
}) => {
  const [uncollapsed, setUncollapsed] = useState(defaultUncollapsedState);
  return (
    <div
      className={`${className} flex flex-col w-full h-fit border border-[#EFF0F2] bg-white rounded-xl`}
    >
      {title && (
        <div
          className={`${collapsible && "hover:cursor-pointer"} ${
            uncollapsed && "border-b border-[#EFF0F2]"
          } flex w-full h-fit py-[16px] px-[24px] items-center justify-between`}
          onClick={() => {
            if (collapsible) {
              setUncollapsed(!uncollapsed);
            }
          }}
        >
          <div className="flex flex-col gap-[8px]">
            <h1 className="text-[16px]">{title}</h1>
            {description && (
              <p className="text-[14px] font-normal">{description}</p>
            )}
          </div>
          {collapsible && (
            <div>
              {uncollapsed ? <ArrowUp2 size="18" /> : <ArrowDown2 size="18" />}
            </div>
          )}
        </div>
      )}
      <AnimatePresence>
        {uncollapsed && (
          <m.div
            className="flex flex-col w-full h-fit"
            style={{ overflow: "hidden" }}
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            {children}
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SectionCard;
